import React from "react";
import Typography from "../Typography/Typography";
import Styles from "./List.module.css";
import { IListProps } from "../../models";

const List: React.FC<IListProps> = (props: IListProps) => {
	const { options = [] } = props;

	if (typeof options[0] === "string") {
		return (
			<div className={`${Styles.list_container} ${props.list_container_class ?? ""}`}>
				{options.map((item: any, index) => (
					<div
						key={index}
						onClick={() => props.setSelectedItem(item)}
						className={`${Styles.list_item} ${props.list_item_class ?? ""}`}
						aria-selected={props.selectedItem === item}
					>
						{props.renderer ? (
							props.renderer(item)
						) : (
							<Typography size="sm" fontFamily="medium" color="secondary">
								{item}
							</Typography>
						)}
					</div>
				))}
			</div>
		);
	} else {
		return (
			<div className={`${Styles.list_container} ${props.list_container_class ?? ""}`}>
				{options.map((item: any, index: number) => (
					<div
						key={index}
						onClick={() => props.setSelectedItem(item)}
						className={`${Styles.list_item} ${props.list_item_class ?? ""}`}
						aria-selected={props.selectedItem == item || props.selectedItem == item?.value}
					>
						{props.renderer ? (
							props.renderer(item)
						) : (
							<Typography size="sm" fontFamily="medium" color="secondary">
								{item?.label}
							</Typography>
						)}
					</div>
				))}
			</div>
		);
	}
};

List.displayName = "List";
export default List;
